import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router';
import {  useHistory} from 'react-router-dom';
import { ReactComponent as ActiveHighlight } from '../styles/svg-components/active-hightlight.svg';
import './LinkButton.scss';

const LinkButton = ({color, title, to, icon, exact}) => {
  const match = useRouteMatch({
    path: to,
    exact: !!exact,
  });
  const history = useHistory()

  useEffect(() => {
    console.log('LinkButton reporting for duty', {color, title, to, icon, exact})
  }, [])

  const clazzes = match ? `nav-link active` : 'nav-link';
  const colorStyle = match ? { color: color } : {};

  return (
    <button type="button" className={clazzes} style={colorStyle} onClick={() => history.push(to)}>
      {match && <ActiveHighlight className="active-link"></ActiveHighlight>}
      {icon && icon()}
      <label className="">{title}</label>
    </button>
  );
};

export default LinkButton;
